import { Widget } from '../Widget';
import {
  ModBaseWidgetCallbacks,
  ModBaseWidgetFdsProperties,
} from '../mods/modBaseWidget';
import { ModCreditCheckProperties } from '../mods/modCreditCheck';
import { ModImportProperties } from '../mods/modImport';
import { ModLanguageProperties } from '../mods/modLanguage';
import { ModProcessctlProperties } from '../mods/modProcessctl';
import { ModSolutionsProperties } from '../mods/modSolutions';

export interface CreditCheckB2BProperties
  extends ModBaseWidgetFdsProperties,
    ModProcessctlProperties,
    ModSolutionsProperties,
    ModImportProperties,
    ModLanguageProperties,
    ModCreditCheckProperties {}

export type CreditCheckB2BCallbacks = ModBaseWidgetCallbacks;

export class CreditCheckB2B extends Widget<
  CreditCheckB2BProperties,
  CreditCheckB2BCallbacks
> {
  /**
   * # CreditCheck credit application
   * Digital account overview in the loan application. CreditCheck is a zero
   * integration solution that provides digital account analysis and visibility
   * into the loan application process.
   *
   * @param container - parent HTML element where the widget will be injected
   * @param target - URL of the environment from which the widget's JS bundle will be fetched. Use this, for example, when testing features that are only released to the sandbox environment. By default, `https://widget-library-finapi-general-live.finapi.io` is used.
   * @param ownerDocument - parent Document where the widget will be injected. For example, shadow root or document fragment. By default, the default top-level document is used.
   * @param customBundleFileName - allows modifying the filename of the widget's JS bundle that will be fetched. This property is useful during dev mode when widgets are generated together into one `main.js` file.
   */
  constructor(
    container: HTMLElement,
    target?: string,
    ownerDocument?: Document,
    customBundleFileName?: string
  ) {
    super(
      'creditcheck',
      container,
      target,
      ownerDocument,
      customBundleFileName,
      { type: 'b2b' }
    );
  }
}
